const inAppFormTypes = Object.freeze({
  PLAINTEXT: '0',
  SELECT: '1',
  MULTISELECT: '2',
  NUMBER: '3',
  DATETIME: '4'
})

const inAppTypes = Object.freeze({
  BANNER: 0,
  FULLSCREEN: 1,
  MODAL: 3,
  HTML: 2,
  INLINE: 4
})

const actionTypes = Object.freeze({
  NONE: 'none',
  URL: 'url',
  DEEPLINK: 'deeplink',
  DISMISS: 'dismiss',
  REQUEST_PUSH_PERMISSION: 'request_push_permission'
})

const typeLabels = Object.freeze({
  0: 'CampaignForm_InApp_Type_Banner',
  1: 'CampaignForm_InApp_Type_FullScreen',
  3: 'CampaignForm_InApp_Type_Modal',
  2: 'CampaignForm_InApp_Type_Html',
  4: 'CampaignForm_InApp_Type_Inline'
})
const orientationLabels = Object.freeze({
  1: 'CampaignForm_InApp_Orientation_Portrait',
  2: 'CampaignForm_InApp_Orientation_Landscape',
  0: 'CampaignForm_InApp_Orientation_Both'
})
const positionLabels = Object.freeze({
  top: 'CampaignForm_InApp_Position_Top',
  center: 'CampaignForm_InApp_Position_Center',
  bottom: 'CampaignForm_InApp_Position_Bottom'
})
const actionLabels = Object.freeze({
  none: 'CampaignForm_InApp_Action_None',
  url: 'CampaignForm_InApp_Action_Url',
  deeplink: 'CampaignForm_InApp_Action_DeepLink',
  dismiss: 'CampaignForm_InApp_Action_Dismiss',
  request_push_permission: 'CampaignForm_InApp_Action_RequestPushPermission'
})
const specialLabels = Object.freeze({
  none: 'CampaignForm_InApp_Special_None',
  set_attribute: 'CampaignForm_InApp_Special_SetAttr',
  add_to_list: 'CampaignForm_InApp_Special_AddToList',
  subscribe_to: 'CampaignForm_InApp_Special_Subscribe'
})

const triggerLabels = Object.freeze({
  none: 'CampaignForm_InApp_Trigger_None',
  trigger_event: 'CampaignForm_InApp_Trigger_Event'
})

const subscriptionLabels = Object.freeze({
  email: 'CampaignForm_InApp_Subscription_Email',
  sms: 'CampaignForm_InApp_Subscription_SMS'
})

const subscriptionTypes = Object.freeze({
  EMAIL: 'email',
  SMS: 'sms'
})

export {
  inAppFormTypes,
  inAppTypes,
  actionTypes,
  typeLabels,
  orientationLabels,
  positionLabels,
  actionLabels,
  specialLabels,
  triggerLabels,
  subscriptionLabels,
  subscriptionTypes
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/InAppTypesEnum.js